//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { isLoading } from 'state/reducers/beneficiary.reducers';
//mui
import { Button, Stack } from '@mui/material';
import { FormButton } from 'theme/elements/Buttons';
import { getMobile } from 'state/reducers/ui.reducers';

type footerProps = {
	handleCancel: any;
	handleBack: any;
	ifBack: boolean;
	handleSubmit: any;
	disableSubmit?: boolean;
	labelSubmit?: string;
	labelCancel?: string;
	labelBack?: string;
};

export default function Footer(props: footerProps) {
	const loading: boolean = useAppSelector(isLoading);
	const t = useAppSelector(selectTranslations);
	const isMobile = useAppSelector(getMobile);

	const className = isMobile ? 'singleFormButton' : '';
	return (
		<Stack
			justifyContent="space-between"
			spacing={{ xs: 1, sm: 0 }}
			display="flex"
			flexDirection={isMobile ? 'column' : 'row'}
		>
			<FormButton>
				<Button
					variant="text"
					className={className}
					disabled={loading}
					onClick={() => {
						props.handleCancel();
					}}
				>
					{props.labelCancel || 'Cancel'}
				</Button>
			</FormButton>
			<Stack gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
				<FormButton>
					{props.ifBack && (
						<Button
							variant="outlined"
							className={className}
							disabled={loading}
							onClick={() => {
								props.handleBack();
							}}
						>
							{props.labelBack || 'Back'}
						</Button>
					)}
				</FormButton>
				<FormButton>
					<Button
						className={className}
						onClick={() => props.handleSubmit()}
						variant="contained"
						disabled={props.disableSubmit}
					>
						{props.labelSubmit || 'Submit'}
					</Button>
				</FormButton>
			</Stack>
		</Stack>
	);
}
